module.exports = __webpack_public_path__ + "static/client_12_before-89cc779a5593e4989271ca8bda8a4b3b.jpg";